import {profile} from 'f3tch';

// Errors
import isApiError from '../validation/isApiError.validation.api';
import isUnauthorized from '../validation/isUnauthorized.validation.api';

// Token
import authStore from '../../auth/lib/token.lib.auth';

const multipartProfile = ({url = '', authorize = true} = {}) =>
  profile(url)
    .headers(() => {
      const token = authStore.get();
      const h = {
        Accept: 'application/json',
      };
      if (!!token && authorize) h.authorization = token;
      return h;
    })
    .responder(async (response) => {
      isUnauthorized({response, authorize});
      await isApiError(response);
      const data = await response.json();
      return data;
    });

export default multipartProfile;
